import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ToggleableFeature } from "@/briefpoint-client";
import { useAuth } from "@/hooks/useAuth";
import GsClients from "@/images/getstarted-clients.svg?react";
import GsDiscovery from "@/images/getstarted-discovery.svg?react";
import GsProduction from "@/images/getstarted-production.svg?react";
import GsPropound from "@/images/getstarted-propound.svg?react";
import GsWorkprod from "@/images/getstarted-workproduct.svg?react";
import { userCanUseFeature } from "@/lib/utils";
import styles from "./TopRibbon.module.scss";

type TopRibbonProps = {
  handleQuickActionUpload: () => void;
  handlePropoundIntroModal: () => void;
  handleUploadProduction: () => void;
};

export function TopRibbon({
  handleQuickActionUpload,
  handlePropoundIntroModal,
  handleUploadProduction,
}: TopRibbonProps) {
  const { user } = useAuth();

  const userCanUseDocHandling = user
    ? userCanUseFeature(user, ToggleableFeature.Autodoc)
    : false;

  return (
    <div className={styles.quickstartWrapper}>
      <h2>What do you want to do?</h2>
      <div className={styles.quickstartContainer}>
        <button
          type="button"
          className={styles.newFeature}
          onClick={handlePropoundIntroModal}
        >
          <GsPropound /> <p>Propound Discovery</p>
          <span>New</span>
        </button>

        <button type="button" onClick={handleQuickActionUpload}>
          <GsDiscovery /> <p>Respond to Discovery</p>
        </button>
        <Link to="/clients">
          <div>
            <GsClients /> <p>View Clients</p>
          </div>
        </Link>
        <Link to="/library?tab=objections">
          <div>
            <GsWorkprod /> <p>Add/Edit Workproduct</p>
          </div>
        </Link>
        {userCanUseDocHandling ? (
          <button
            data-testid="upload-production-button"
            type="button"
            onClick={handleUploadProduction}
          >
            <GsProduction /> <p>Upload Production</p>
          </button>
        ) : (
          <OverlayTrigger
            placement="bottom"
            overlay={
              <Tooltip>
                Briefpoint’s Autodoc isn’t enabled for your account. To request
                access, please contact your firm’s administrator.
              </Tooltip>
            }
          >
            <button type="button" className="opacity-50">
              <GsProduction /> <p>Upload Production</p>
            </button>
          </OverlayTrigger>
        )}
      </div>
    </div>
  );
}
